// Mock data for NAGOC GROUP tech store - UPDATED WITH VARIED PINTEREST-STYLE IMAGES

export const products = [
  // TCL TVs - PRODUCTO COMO PROTAGONISTA ABSOLUTO
  {
    id: 'tv-tcl-32',
    name: 'Televisor TCL 32" Smart Google TV',
    category: 'televisores',
    brand: 'TCL',
    price: 10990,
    image: 'https://images.unsplash.com/photo-1567690187548-f07b1d7bf5a9', // TV protagonista pared blanca
    description: 'Smart TV con Google TV integrado, resolución HD, acceso a todas tus apps favoritas.',
    features: ['Google TV', 'HD Ready', 'Chromecast integrado', 'Asistente de voz'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-tcl-40',
    name: 'Televisor TCL 40" Google TV',
    category: 'televisores',
    brand: 'TCL',
    price: 14990,
    image: 'https://images.unsplash.com/photo-1761330439671-a7f20c285c5e', // TV grande protagonista sala moderna
    description: 'Experiencia de entretenimiento completa con Google TV y pantalla Full HD.',
    features: ['Google TV', 'Full HD', 'HDR', 'Dolby Audio'],
    warranty: '1 año',
    featured: true
  },
  {
    id: 'tv-tcl-50',
    name: 'Televisor TCL 50" Google TV',
    category: 'televisores',
    brand: 'TCL',
    price: 23990,
    image: 'https://images.unsplash.com/photo-1697457643599-77b5d074121f', // TV en stand minimalista - producto claro
    description: 'Pantalla grande con tecnología 4K y Google TV para entretenimiento sin límites.',
    features: ['4K UHD', 'Google TV', 'HDR10', 'Dolby Atmos'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-tcl-55',
    name: 'Televisor TCL 55" Google TV',
    category: 'televisores',
    brand: 'TCL',
    price: 24990,
    image: 'https://images.unsplash.com/photo-1640386595331-95887ea1a083', // TV roja protagonista en sala
    description: 'Smart TV 4K con experiencia cinematográfica en casa.',
    features: ['4K UHD', 'Google TV', 'HDR10+', 'Game Mode'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-tcl-55-q6',
    name: 'Televisor TCL 55" Google Q6',
    category: 'televisores',
    brand: 'TCL',
    price: 28990,
    image: 'https://images.unsplash.com/photo-1698046999121-439806d2c4f8', // TV en mueble negro - producto claro
    description: 'QLED con colores vibrantes y tecnología quantum dot.',
    features: ['QLED', '4K UHD', 'Quantum Dot', 'Variable Refresh Rate'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-tcl-55-qled',
    name: 'Televisor TCL 55" QLED Q7 (2025)',
    category: 'televisores',
    brand: 'TCL',
    price: 29990,
    image: 'https://images.unsplash.com/photo-1751806524629-e0ec1d37648c', // TV protagonista con luz cálida
    description: 'Lo último en tecnología QLED con procesador de imagen avanzado.',
    features: ['QLED 2025', 'Mini LED', '120Hz', 'Dolby Vision IQ'],
    warranty: '1 año',
    featured: true
  },
  {
    id: 'tv-tcl-65',
    name: 'Televisor TCL 65" Google TV',
    category: 'televisores',
    brand: 'TCL',
    price: 36990,
    image: 'https://images.unsplash.com/photo-1772475329856-7c7de908b44e', // TV grande protagonista
    description: 'Pantalla gigante para experiencia inmersiva total.',
    features: ['4K UHD', '65 pulgadas', 'HDR10+', 'DTS Virtual:X'],
    warranty: '1 año',
    featured: false
  },
  
  // Samsung TVs - PRODUCTO PROTAGONISTA
  {
    id: 'tv-samsung-32',
    name: 'Televisor Samsung 32" Smart TV 2024',
    category: 'televisores',
    brand: 'Samsung',
    price: 11990,
    image: 'https://images.pexels.com/photos/6020432/pexels-photo-6020432.jpeg', // TV en pared blanca minimalista
    description: 'Smart TV Samsung con Tizen OS y diseño elegante.',
    features: ['Tizen OS', 'HD Ready', 'Smart Hub', 'Q-Symphony'],
    warranty: '1 año',
    featured: true
  },
  {
    id: 'tv-samsung-55',
    name: 'Televisor Samsung 55"',
    category: 'televisores',
    brand: 'Samsung',
    price: 28990,
    image: 'https://images.unsplash.com/photo-1761330439671-a7f20c285c5e', // TV protagonista
    description: 'Calidad Samsung con Crystal UHD y procesador Crystal 4K.',
    features: ['Crystal UHD', '4K', 'Motion Xcelerator', 'OTS Lite'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-samsung-65',
    name: 'Televisor Samsung 65"',
    category: 'televisores',
    brand: 'Samsung',
    price: 38990,
    image: 'https://images.unsplash.com/photo-1698047575401-c51c09e6e9ab', // TV en stand moderno
    description: 'Experiencia premium con pantalla grande y tecnología Crystal.',
    features: ['Crystal UHD', '65 pulgadas', 'HDR10+', 'Adaptive Sound'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-samsung-75',
    name: 'Televisor Samsung 75"',
    category: 'televisores',
    brand: 'Samsung',
    price: 52990,
    image: 'https://images.unsplash.com/photo-1567690187548-f07b1d7bf5a9', // TV protagonista grande
    description: 'El tamaño más grande para cine en casa real.',
    features: ['Crystal UHD', '75 pulgadas', 'Q-Symphony', 'Game Mode Pro'],
    warranty: '1 año',
    featured: false
  },

  // LG TVs - PRODUCTO PROTAGONISTA
  {
    id: 'tv-lg-55',
    name: 'Televisor LG 55"',
    category: 'televisores',
    brand: 'LG',
    price: 28990,
    image: 'https://images.unsplash.com/photo-1640386595331-95887ea1a083', // TV roja protagonista
    description: 'Smart TV LG con webOS y procesador α5 Gen 6.',
    features: ['webOS', '4K UHD', 'AI ThinQ', 'Filmmaker Mode'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-lg-65',
    name: 'Televisor LG 65"',
    category: 'televisores',
    brand: 'LG',
    price: 39990,
    image: 'https://images.unsplash.com/photo-1761330439671-a7f20c285c5e', // TV grande protagonista
    description: 'Tecnología LG NanoCell con colores puros.',
    features: ['NanoCell', '65 pulgadas', 'α7 Gen 6', 'Dolby Atmos'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'tv-lg-75',
    name: 'Televisor LG 75"',
    category: 'televisores',
    brand: 'LG',
    price: 55990,
    image: 'https://images.unsplash.com/photo-1697457643599-77b5d074121f', // TV en stand protagonista
    description: 'Pantalla masiva con tecnología avanzada de imagen.',
    features: ['NanoCell', '75 pulgadas', 'HDMI 2.1', 'Magic Remote'],
    warranty: '1 año',
    featured: false
  },

  // Air Conditioners - AIRE COMO PROTAGONISTA
  {
    id: 'ac-tgm-12',
    name: 'Aire acondicionado inverter TGM 12,000 BTU',
    category: 'aires',
    brand: 'TGM',
    price: 22990,
    image: 'https://images.unsplash.com/photo-1757219525975-03b5984bc6e8', // AC unit protagonista claro
    description: 'Tecnología inverter para máximo ahorro de energía y confort continuo.',
    features: ['Inverter', '12,000 BTU', 'Ahorro energético', 'Modo silencioso'],
    warranty: '1 año',
    featured: true
  },
  {
    id: 'ac-tcl-18',
    name: 'Aire acondicionado inverter TCL 18,000 BTU',
    category: 'aires',
    brand: 'TCL',
    price: 37990,
    image: 'https://images.unsplash.com/photo-1647022528152-52ed9338611d', // AC exterior protagonista
    description: 'Potencia para espacios medianos con eficiencia inverter.',
    features: ['Inverter', '18,000 BTU', 'WiFi Control', 'Filtro antibacterial'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'ac-tcl-24',
    name: 'Aire acondicionado inverter TCL 24,000 BTU',
    category: 'aires',
    brand: 'TCL',
    price: 50990,
    image: 'https://images.unsplash.com/photo-1658415198885-6ec6121cabc8', // Vent unit close up
    description: 'Máxima capacidad para espacios grandes con control inteligente.',
    features: ['Inverter', '24,000 BTU', 'Smart Control', 'Turbo Cooling'],
    warranty: '1 año',
    featured: false
  },

  // Small Appliances - VARIADOS
  {
    id: 'appliance-sandwich',
    name: 'Sandwichera Universal',
    category: 'electrodomesticos',
    brand: 'Universal',
    price: 2890,
    image: 'https://images.unsplash.com/photo-1769326541210-86e9d3204496', // Cocina moderna con stove
    description: 'Sandwichera compacta y eficiente para desayunos perfectos.',
    features: ['Antiadherente', 'Compacta', 'Indicador LED', 'Fácil limpieza'],
    warranty: '3 meses',
    featured: false
  },
  {
    id: 'appliance-microwave-ihome',
    name: 'Microondas iHome negro',
    category: 'electrodomesticos',
    brand: 'iHome',
    price: 5990,
    image: 'https://images.unsplash.com/photo-1769326541179-1c496f7c5104', // Kitchen con pancakes y counter
    description: 'Microondas moderno con múltiples niveles de potencia.',
    features: ['0.7 cu ft', 'Digital', '10 niveles', 'Descongelado rápido'],
    warranty: '6 meses',
    featured: false
  },
  {
    id: 'appliance-dispenser',
    name: 'Dispensador de agua blanco',
    category: 'electrodomesticos',
    brand: 'Universal',
    price: 6890,
    image: 'https://images.unsplash.com/photo-1769326541231-c6bd945b75f9', // Espresso machine en counter elegante
    description: 'Agua fría y caliente al instante con diseño elegante.',
    features: ['Frío/Caliente', 'Botellón superior', 'Bandeja antigoteo', 'Bajo consumo'],
    warranty: '6 meses',
    featured: false
  },
  {
    id: 'appliance-blender-american',
    name: 'Licuadora American',
    category: 'electrodomesticos',
    brand: 'American',
    price: 3190,
    image: 'https://images.unsplash.com/photo-1762186540963-efa1702b3379', // Kitchen counter con appliances
    description: 'Licuadora potente para batidos y mezclas perfectas.',
    features: ['3 velocidades', 'Vaso de vidrio', '1.5 litros', 'Base antideslizante'],
    warranty: '6 meses',
    featured: false
  },
  {
    id: 'appliance-blender-oster',
    name: 'Licuadora Oster',
    category: 'electrodomesticos',
    brand: 'Oster',
    price: 4190,
    image: 'https://images.unsplash.com/photo-1769326541231-c6bd945b75f9', // Cocina moderna con appliances
    description: 'Calidad Oster con motor duradero y cuchillas de acero.',
    features: ['Motor 600W', 'Vaso de vidrio', 'Cuchillas reversibles', 'Garantía extendida'],
    warranty: '1 año',
    featured: false
  },
  {
    id: 'appliance-blender-ninja',
    name: 'Licuadora Ninja',
    category: 'electrodomesticos',
    brand: 'Ninja',
    price: 7490,
    image: 'https://images.unsplash.com/photo-1762186540963-efa1702b3379', // Kitchen setup premium
    description: 'Tecnología profesional Ninja para resultados perfectos.',
    features: ['1000W', 'Sistema Total Crushing', 'Vasos portátiles', 'Cuchillas Ninja'],
    warranty: '1 año',
    featured: true
  },

  // Fans - VARIADOS
  {
    id: 'fan-pedestal-american',
    name: 'Abanico pedestal American',
    category: 'abanicos',
    brand: 'American',
    price: 2490,
    image: 'https://images.unsplash.com/photo-1612549672719-2f1a3908ae31', // Pedestal fan realista
    description: 'Ventilador de pedestal con altura ajustable.',
    features: ['3 velocidades', 'Altura ajustable', 'Oscilación', 'Base estable'],
    warranty: '3 meses',
    featured: false
  },
  {
    id: 'fan-wall-american',
    name: 'Abanico de pared American',
    category: 'abanicos',
    brand: 'American',
    price: 2390,
    image: 'https://images.unsplash.com/photo-1572081790780-1a7739896259', // Wall fan ventilador
    description: 'Ventilador de pared con control remoto.',
    features: ['3 velocidades', 'Control remoto', 'Montaje fácil', 'Silencioso'],
    warranty: '3 meses',
    featured: false
  },
  {
    id: 'fan-pedestal-universal',
    name: 'Abanico pedestal Universal',
    category: 'abanicos',
    brand: 'Universal',
    price: 3490,
    image: 'https://images.unsplash.com/photo-1598492665673-f853ef03add4', // Fan moderno
    description: 'Ventilador premium con temporizador y control remoto.',
    features: ['Control remoto', 'Temporizador', '3 velocidades', 'Oscilación 90°'],
    warranty: '6 meses',
    featured: false
  },
  {
    id: 'fan-wall-universal',
    name: 'Abanico de pared Universal',
    category: 'abanicos',
    brand: 'Universal',
    price: 3790,
    image: 'https://images.unsplash.com/photo-1572081790780-1a7739896259', // Wall fan premium
    description: 'Ventilador de pared premium con motor silencioso.',
    features: ['Motor silencioso', 'Control remoto', 'Timer 7.5hrs', 'Aspas metálicas'],
    warranty: '6 meses',
    featured: false
  },

  // Audio - BARRA DE SONIDO PROTAGONISTA
  {
    id: 'audio-soundbar-tcl',
    name: 'Barra de sonido TCL',
    category: 'audio',
    brand: 'TCL',
    price: 9790,
    image: 'https://images.unsplash.com/photo-1604914416956-38b08c516877', // Soundbar protagonista con TV
    description: 'Sonido envolvente para tu entretenimiento en casa.',
    features: ['Dolby Audio', 'Bluetooth', 'Subwoofer incluido', 'HDMI ARC'],
    warranty: '1 año',
    featured: true
  }
];

export const categories = [
  { id: 'todos', name: { es: 'Todos', en: 'All' }, icon: 'Grid3x3' },
  { id: 'televisores', name: { es: 'Televisores', en: 'TVs' }, icon: 'Tv' },
  { id: 'aires', name: { es: 'Aires Acondicionados', en: 'Air Conditioners' }, icon: 'Wind' },
  { id: 'electrodomesticos', name: { es: 'Electrodomésticos', en: 'Appliances' }, icon: 'UtensilsCrossed' },
  { id: 'abanicos', name: { es: 'Abanicos', en: 'Fans' }, icon: 'Fan' },
  { id: 'audio', name: { es: 'Audio', en: 'Audio' }, icon: 'Speaker' }
];

export const companyInfo = {
  name: 'NAGOC GROUP, S.R.L',
  phone: '+18093257678',
  email: 'gh@nagocgroup.com',
  rnc: '1-33-59430-7',
  address: 'Calle Penetración 10A, Santiago de los Caballeros, 51000',
  website: 'nagocgroup.com',
  social: {
    whatsapp: '+18093257678'
  }
};

// Exact monthly payments per product (NO automatic calculation)
const monthlyPayments = {
  // TCL TVs
  'tv-tcl-32': 1990,
  'tv-tcl-40': 2490,
  'tv-tcl-50': 2990,
  'tv-tcl-55': 3090,
  'tv-tcl-55-q6': 3490,
  'tv-tcl-55-qled': 3590,
  'tv-tcl-65': 3990,
  
  // Samsung TVs
  'tv-samsung-32': 2090,
  'tv-samsung-55': 3490,
  'tv-samsung-65': 4190,
  'tv-samsung-75': 4990,
  
  // LG TVs
  'tv-lg-55': 3490,
  'tv-lg-65': 4290,
  'tv-lg-75': 5190,
  
  // Air Conditioners
  'ac-tgm-12': 2890,
  'ac-tcl-18': 3990,
  'ac-tcl-24': 4790,
  
  // Small Appliances
  'appliance-sandwich': 490,
  'appliance-microwave-ihome': 690,
  'appliance-dispenser': 790,
  'appliance-blender-american': 490,
  'appliance-blender-oster': 590,
  'appliance-blender-ninja': 890,
  
  // Fans
  'fan-pedestal-american': 390,
  'fan-wall-american': 390,
  'fan-pedestal-universal': 490,
  'fan-wall-universal': 490,
  
  // Audio
  'audio-soundbar-tcl': 990
};

// Get exact monthly payment for a product (NO calculation)
export const calculateMonthlyPayment = (price, productId) => {
  // If productId is provided and exists in the map, return exact value
  if (productId && monthlyPayments[productId]) {
    return monthlyPayments[productId];
  }
  
  // Fallback for products not in the map (should not happen)
  return Math.ceil(price / 10);
};
